import loadable from "@loadable/component";
const ThankyouPage = loadable(() =>
  import(/* webpackChunkName: "thankyou-page"*/ "./")
);
export default ThankyouPage;
